export const mycouponRoutes = [{
  path: '/mycoupon',
  name: 'mycoupon',
  component: () => {
    return import('../views/page/mycoupon/index.vue')
  },
  redirect: '/mycoupon/valid',
  children: [{
    path: 'valid',
    name: 'mycoupon.valid',
    component: () => {
      return import('@/views/page/mycoupon/valid.vue')
    },
    meta: {
      title: '优惠券'
    }
  }, {
    path: 'invalid',
    name: 'mycoupon.invalid',
    component: () => {
      return import('@/views/page/mycoupon/invalid.vue')
    },
    meta: {
      title: '历史优惠券'
    }
  }]
}]
